/**
 * 观看有礼服务
 * @returns
 */
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';
import { watchGiftApi } from '@/request/index.js';

class WatchGiftServer extends BaseServer {
  constructor() {
    if (typeof WatchGiftServer.instance === 'object') {
      return WatchGiftServer.instance;
    }
    super();

    this.state = {};

    WatchGiftServer.instance = this;

    this.listenMsg()
    return this;
  }

  setState(key, value) {
    this.state[key] = value;
  }

  listenMsg() {
    // 房间消息
    useMsgServer().$onMsg('ROOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      // console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 计时器开始
        case 'reward_pay_ok':
          this.$emit('reward_pay_ok', temp);
          break;

        // 观看有礼开始消息
        case 'watch_gift_open':
        // 观看有礼结束消息
        case 'watch_gift_end':
        // 直播结束
        case 'live_over':
          this.$emit(type, temp);
          break;

        default:
          break;
      }
    });
    // 自定义消息
    useMsgServer().$onMsg('CUSTOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 计时器暂停
        case 'timer_pause':
          this.$emit('timer_pause', temp);
          break;
        default:
          break;
      }
    });
  }

  getWatchGiftConfig(params) {
    return watchGiftApi.getWatchGiftConfig(params);
  }

  switchWatchGift(params) {
    return watchGiftApi.switchWatchGift(params);
  }

  getWatchRewardList(params) {
    return watchGiftApi.getWatchRewardList(params);
  }
  pushWatchReward(params) {
    return watchGiftApi.pushWatchReward(params);
  }
  endWatchReward(params) {
    return watchGiftApi.endWatchReward(params);
  }

  getReceiveAwardSetting(params) {
    return watchGiftApi.getReceiveAwardSetting(params);
  }
  getLastInfo(params) {
    return watchGiftApi.getLastInfo(params);
  }
  participate(params) {
    return watchGiftApi.participate(params);
  }
  getWinnerDetail(params) {
    return watchGiftApi.getWinnerDetail(params);
  }
  getWinnerList(params) {
    return watchGiftApi.getWinnerList(params);
  }
  getLiveWinnerList(params) {
    return watchGiftApi.getLiveWinnerList(params);
  }
  getWinnerRank(params) {
    return watchGiftApi.getWinnerRank(params);
  }
  getTakeAwardRemark(params) {
    return watchGiftApi.getTakeAwardRemark(params);
  }
  saveTakeAwardRemark(params) {
    return watchGiftApi.saveTakeAwardRemark(params);
  }
  getAwardList(params) {
    return watchGiftApi.getAwardList(params);
  }
  getInfo(params) {
    return watchGiftApi.requestInfo(params);
  }
  doAdd(params) {
    return watchGiftApi.requestAdd(params);
  }
  doEdit(params) {
    return watchGiftApi.requestEdit(params);
  }
  doCopy(params) {
    return watchGiftApi.requestCopy(params);
  }
  doDelete(params) {
    return watchGiftApi.requestDelete(params);
  }
  saveReceiveSetting(params) {
    return watchGiftApi.requestSaveReceiveSetting(params);
  }
  getReceiveSetting(params) {
    return watchGiftApi.requestGetReceiveSetting(params);
  }
  getAwardListForLive(params) {
    return watchGiftApi.requestAwardListForLive(params);
  }
  sortAwardList(params) {
    return watchGiftApi.requestSortAwardList(params);
  }
}

export default function useWatchGiftServer() {
  return new WatchGiftServer();
}
